import styled from 'styled-components';

const StyledFileDropzone = styled.div`
  .dropzone {
    padding: 40px;
    border: 1px dashed
      ${(props) => (props.isError ? '#FF3B30' : 'rgba(30, 22, 78, 0.32)')};
    background: rgba(244, 245, 247, 0.64);
    backdrop-filter: blur(8px);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    cursor: pointer;

    &.hightlight {
      background: rgba(30, 22, 78, 0.08);
    }

    &.uploaded {
      cursor: default;
    }
  }

  .file-input {
    display: none;
  }

  .upload-icon {
    font-size: 32px;
    color: #1c1c1e;
  }

  .upload-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.4px;
    text-align: center;
    color: #1c1c1e;
    margin: 0;
  }

  .upload-description {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    text-align: center;

    p {
      margin: 0;
    }
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    color: #ff3b30;
    margin: 0;
  }

  .file-item {
    background: white;
    border: 0.5px solid rgba(30, 22, 78, 0.16);
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    box-sizing: border-box;
  }

  .file-icon-wrapper {
    padding: 4px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .file-icon {
    width: 32px;
    height: 32px;
  }

  .file-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .file-name {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.4px;
    color: #1c1c1e;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .file-details {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    display: flex;
    align-items: center;
    gap: 4px;

    .file-details-dot {
      background-color: rgba(28, 28, 30, 0.16);
      width: 4px;
      height: 4px;
      border-radius: 50%;
    }
  }
`;

export { StyledFileDropzone };
